// Idioma de la interfaz. Se resuelve una vez al cargar el modulo, en este
// orden: el parametro ?lang= de la URL (sirve para enlazar la demo en un
// idioma), lo elegido antes en este navegador y el idioma del navegador.
// Cambiar de idioma recarga la pagina, asi que ningun componente necesita
// estado ni contexto: `txt` lee un diccionario ya fijo.
import TEXTOS from './textos';

const POR_DEFECTO = 'es';
const CLAVE_GUARDADA = 'idioma';

function detecta() {
  const pedido = new URLSearchParams(window.location.search).get('lang');
  if (pedido && TEXTOS[pedido]) return pedido;
  try {
    const guardado = window.localStorage.getItem(CLAVE_GUARDADA);
    if (guardado && TEXTOS[guardado]) return guardado;
  } catch (e) {
    // localStorage bloqueado (navegacion privada): queda el del navegador
  }
  const navegador = (window.navigator.language || POR_DEFECTO).slice(0, 2);
  return TEXTOS[navegador] ? navegador : POR_DEFECTO;
}

export const IDIOMA = detecta();
export const OTRO_IDIOMA = IDIOMA === 'es' ? 'en' : 'es';

// Si falta una clave cae al castellano antes que a la clave cruda, para que
// un texto sin traducir se vea como texto y no como identificador.
export function txt(clave) {
  return TEXTOS[IDIOMA][clave] ?? TEXTOS[POR_DEFECTO][clave] ?? clave;
}

export function cambiaIdioma(idioma) {
  try {
    window.localStorage.setItem(CLAVE_GUARDADA, idioma);
  } catch (e) {
    // sin localStorage el parametro de la URL sostiene la eleccion
  }
  const url = new URL(window.location.href);
  url.searchParams.set('lang', idioma);
  window.location.assign(url.toString());
}
